export default __webpack_public_path__ + "static/media/fail_web.c9f621ab.svg";